import React from 'react'
import GlobalStorage from '../storage/GlobalStorage'
import {Container,Collapse,Navbar,NavbarToggler,NavbarBrand,Nav,NavItem,NavLink,UncontrolledDropdown,DropdownToggle,DropdownMenu,DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser} from '@fortawesome/free-solid-svg-icons'


export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
    this.GS = new GlobalStorage();
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render()
  {
    return (
        <div>
          <Navbar color="dark" dark expand="md">
            <Container>
              <NavbarBrand href="https://tbcstory.com/">tbc... {(global.DEBUG)?'(Home)':''}</NavbarBrand>
              <NavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                {this.GS.getUser().token!==null?(
                  <NavItem>
                    <NavLink href="#" onClick={()=>{
                        this.props.switchMain('StoryList');
                        this.props.switchMenu("StoryList");                    
                      }}>我的故事</NavLink>
                  </NavItem>
                ):null}
                  <NavItem>
                    <NavLink href="#" onClick={()=>{
                      this.props.switchMain('FAQ');
                      this.props.switchMenu("FAQ");                    
                    }}>常見問題</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="#" className="active" onClick={()=>{
                      this.props.switchMain('Home');
                      this.props.switchMenu("Home");                    
                    }}>教學</NavLink>
                  </NavItem>
                  {this.GS.getUser().token!==null?(
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                      Hello, {this.GS.getUser().reader.displayName} 
                      <FontAwesomeIcon className="ml-1" icon={faUser}/>
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem onClick={()=>{
                        this.props.toggleModalState('updateMemberProfile');
                        this.props.toggleModal(true);
                      }}>
                        設定
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem onClick={()=>{this.GS.logout();
                        this.props.switchMain('Home');
                        this.props.switchMenu("Home");                    
                      }}>
                        登出
                      </DropdownItem>                      
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  ):(
                    <NavItem>
                      <NavLink href="#" onClick={()=>{
                        this.props.toggleModalState('login');
                        this.props.toggleModal(true);
                      }}>登入</NavLink>
                    </NavItem>
                  )}
                </Nav>
              </Collapse>
            </Container>
          </Navbar>
        </div>
    )
  }
}